"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagEditState = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var input_state_1 = require("../components/input/input.state");
var TagEditState = /** @class */ (function () {
    function TagEditState(text) {
        this.input = new input_state_1.InputState(text);
    }
    TagEditState.prototype.setTagId = function (tagId) {
        this.tagId = tagId;
    };
    TagEditState.prototype.setRenaming = function (tagId) {
        this.renamingTagId = tagId;
    };
    TagEditState.prototype.cancelRenaming = function () {
        this.setRenaming(undefined);
    };
    TagEditState.prototype.editTag = function (tagId, value) {
        this.setTagId(tagId);
        this.input.setValue(value);
    };
    TagEditState.prototype.isEditingTag = function (tagId) {
        if (tagId == null) {
            return this.input.value != null;
        }
        return this.input.value != null && this.tagId === tagId;
    };
    TagEditState.prototype.isRenamingTag = function (tagId) {
        if (tagId == null) {
            return this.renamingTagId != null;
        }
        return this.renamingTagId === tagId;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], TagEditState.prototype, "tagId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TagEditState.prototype, "renamingTagId", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], TagEditState.prototype, "setTagId", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagEditState.prototype, "setRenaming", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagEditState.prototype, "cancelRenaming", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagEditState.prototype, "editTag", null);
    return TagEditState;
}());
exports.TagEditState = TagEditState;
//# sourceMappingURL=tag.edit.state.js.map